import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyDatePicker from '../../../components/forms/datePicker'

const AddAlmamaterVisitCategory = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '母校行分类名称不能为空'})
      return false
    }    

    axios.post('/p/almamater_visit/category/add', {
      merchant_oid: merchantOid,
      name: formValue.name,
      start_time: formValue.start_time,
      end_time: formValue.end_time
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('创建成功！')
          props.getAlmamaterVisitCategoryList()
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="创建母校行分类"
        width='600px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyInput
          id="name"
          required
          autoFocus
          maxLength={64}
          label='名称'
          placeholder='请输入母校行分类的名称'
          value={formValue.name}
          onChange={setFormValue}
          errorMsg={errorMsg.nameEmpty}
        />

        <MyDatePicker
          id="start_time"
          label='开始时间'
          placeholder='选择时间'
          value={formValue.start_time}
          onChange={setFormValue}
          styles={{width: '360px'}}
          showTime
        />

        <MyDatePicker
          id="end_time"
          label='结束时间'
          placeholder='选择时间'
          value={formValue.end_time}
          onChange={setFormValue}
          styles={{width: '360px'}}
          showTime
        />
      </Modal>
    </>
  )
}

export default AddAlmamaterVisitCategory
